import DatePicker from 'antd/es/date-picker';
import { Day, getMilliseconds, getWeek, isValid, parse, setMilliseconds, startOfWeek } from 'date-fns';
import { enUS } from 'date-fns/locale';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import { getLocale } from '../../../Utilities/DateEx';
import { settings } from '../../../context/network/http/QueryProvider/queries/UISettings';
import { format, localeParse } from '../helpers';

export const {
    //
    RangePicker,
    MonthPicker,
    QuarterPicker,
    TimePicker,
    WeekPicker,
    YearPicker,
} = DatePicker.generatePicker<Date>({
    //
    ...dateFnsGenerateConfig,
    getMillisecond: getMilliseconds,
    setMillisecond: setMilliseconds,
    locale: {
        getWeekFirstDay(_) {
            const uiSettings = settings();
            return uiSettings?.useISO8601 ? 1 : 7;
        },
        getWeekFirstDate(_, date) {
            const locale = getLocale();
            const uiSettings = settings();
            return startOfWeek(date, {
                locale: {
                    ...locale,
                    options: {
                        ...locale.options,
                        weekStartsOn: (uiSettings?.useISO8601 ? 1 : 7) as Day,
                    },
                },
            });
        },
        getWeek(_, date) {
            return getWeek(date, {
                locale: getLocale(),
            });
        },
        getShortWeekDays(_) {
            return Array.from({ length: 7 }, (_, i) => {
                return enUS.localize.day(i as Day, {
                    width: 'short',
                });
            });
        },
        getShortMonths(_) {
            return Array.from({ length: 12 }, (_, i) => {
                return enUS.localize.month(i as Day, {
                    width: 'abbreviated',
                });
            });
        },
        format(_, date, _format) {
            return format(date, _format);
        },
        parse(_, text, formats) {
            for (const format of formats) {
                const parsedFormat = localeParse(format);
                const formatText = text;
                const date = parse(formatText, parsedFormat, new Date(), {
                    locale: getLocale(),
                });
                if (isValid(date)) {
                    return date;
                }
            }
            return null;
        },
    },
});
export type RangePickerProps = Parameters<typeof RangePicker>[0];
export type PickerMode = RangePickerProps['picker'];
export type CellRender = RangePickerProps['cellRender'];
export type CellRenderInfo = Parameters<CellRender>[1];
